import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions, httpsCallable } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBkb0hyxtFatozN6l5C_MVTT1pmoqc88Ec",
  authDomain: "m-amigo.firebaseapp.com",
  databaseURL: "https://m-amigo-default-rtdb.firebaseio.com",
  projectId: "m-amigo",
  storageBucket: "m-amigo.firebasestorage.app",
  messagingSenderId: "118887179993",
  appId: "1:118887179993:web:6d86187862527a7fdfc0c8",
  measurementId: "G-HD5DHDDZ7M",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, "us-central1");

// Phase 7.5 — typed callable wrappers. Each returns a Promise<result.data>.
export const callFlagItemOOS = (data) => httpsCallable(functions, "flagItemOOS")(data).then((r) => r.data);
export const callResolveOOSHold = (data) => httpsCallable(functions, "resolveOOSHold")(data).then((r) => r.data);
export const callProcessImageUpload = (data) => httpsCallable(functions, "processImageUpload")(data).then((r) => r.data);
export const callPreviewCatalogueSync = (data) => httpsCallable(functions, "previewCatalogueSync")(data).then((r) => r.data);
export const callApplyCatalogueSync = (data) => httpsCallable(functions, "applyCatalogueSync")(data).then((r) => r.data);
export const callDeactivateCoupon = (data) => httpsCallable(functions, "deactivateCoupon")(data).then((r) => r.data);

export { app, auth, db, storage, functions };
